<template>
<div></div>
</template>

<script>

export default {
  name: "Accueil",
  mounted(){
   if(!this.$route.params.jeton){
      // TODO: informer l'usager qu'il n'a pas de jeton valide
      console.error("Aucun jeton de session détecté, toutes les requêtes au serveur seront invalides.")
    }
    let rechercher = this.$router.resolve({ name:this.$route.params.redirection })
    window.location.href = `${window.location.origin}${rechercher.href}`;
  },
}
</script>
